import { Observable } from "rxjs";

import st from "lib/utils/index";
import { PaymentProfileDecorator } from "lib/decorators/index";
import { PaymentProfilesRepository } from "lib/repositories/index";
import { createResourceInstance, createFormInstance } from "modules/utils/index";
import { pushRoute, createAlert, removeAlert } from "modules/app/actions";

export const OPEN = "settings/EditPaymentProfileModal/OPEN";
export const CLOSE = "settings/EditPaymentProfileModal/CLOSE";

export const LOAD_PROFILE = "settings/EditPaymentProfileModal/LOAD_PROFILE";
export const FETCH_PROFILE = "settings/EditPaymentProfileModal/FETCH_PROFILE";
export const FETCH_PROFILE_START = "settings/EditPaymentProfileModal/FETCH_PROFILE_START";
export const FETCH_PROFILE_SUCCESS = "settings/EditPaymentProfileModal/FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAILURE = "settings/EditPaymentProfileModal/FETCH_PROFILE_FAILURE";

export const INITIALIZE_MODEL = "settings/EditPaymentProfileModal/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/EditPaymentProfileModal/UPDATE_MODEL";
export const VALIDATE = "settings/EditPaymentProfileModal/VALIDATE";
export const SUBMIT = "settings/EditPaymentProfileModal/SUBMIT";
export const FETCH_SUBMIT_START = "settings/EditPaymentProfileModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/EditPaymentProfileModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/EditPaymentProfileModal/FETCH_SUBMIT_FAILURE";

export const REMOVE = "settings/EditPaymentProfileModal/REMOVE";
export const FETCH_REMOVE_START = "settings/EditPaymentProfileModal/FETCH_REMOVE_START";
export const FETCH_REMOVE_SUCCESS = "settings/EditPaymentProfileModal/FETCH_REMOVE_SUCCESS";
export const FETCH_REMOVE_FAILURE = "settings/EditPaymentProfileModal/FETCH_REMOVE_FAILURE";

export const stateSelector = (state) => state.settings.EditPaymentProfileModal;

const resourceInstance = createResourceInstance({
  LOAD: LOAD_PROFILE,
  FETCH: FETCH_PROFILE,
  FETCH_START: FETCH_PROFILE_START,
  FETCH_SUCCESS: FETCH_PROFILE_SUCCESS,
  FETCH_FAILURE: FETCH_PROFILE_FAILURE,
  stateSelector,
  stateKey: "profile",
  getModel: ({ profileId }) => {
    return PaymentProfilesRepository.find(profileId);
  },
});

const removeResourceInstance = createResourceInstance({
  FETCH: REMOVE,
  FETCH_START: FETCH_REMOVE_START,
  FETCH_SUCCESS: FETCH_REMOVE_SUCCESS,
  FETCH_FAILURE: FETCH_REMOVE_FAILURE,
  stateSelector,
  stateKey: "profileRemoval",
  getModel: ({ profileId }) => {
    if (!profileId) {
      return Observable.empty();
    }
    return PaymentProfilesRepository.delete(profileId);
  },
});

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model: pp } }, errors, { submitValidate }) => {
    errors.add(`payment_profile.name`, st.validators.presence(pp.name));
    // pp.translations.forEach(t => {
    //   errors.add(`payment_profile.name`, st.validators.presence(t.name))
    // })

    if (submitValidate && pp.has_additional_fee) {
      errors.add(
        `payment_profile.additional_fee`,
        st.validators.presence(pp.additional_fee_or_percentage && pp.additional_fee_or_percentage.value)
      );
      pp.additional_fee_or_percentage &&
        errors.add(
          `payment_profile.additional_fee`,
          st.validators.range(pp.additional_fee_or_percentage.value, { greater_than: 0 })
        );
    }
  },
  submitModel: ({ form: { initialModel, model } }) => {
    return model.id ? PaymentProfilesRepository.update(model, initialModel) : PaymentProfilesRepository.create(model);
  },
});

const initialState = {
  opened: false,
  profileId: null,
  profile: resourceInstance.initialState,
  form: formInstance.initialState,
  profileRemoval: removeResourceInstance.initialState,
};

const reducers = {
  ...resourceInstance.reducersMap,
  ...formInstance.reducersMap,
  ...removeResourceInstance.reducersMap,

  [OPEN]: (state, { profile }) => ({
    ...initialState,
    opened: true,
    profileId: profile.id,
  }),

  [CLOSE]: (state) => ({
    ...state,
    opened: false,
  }),
};

const epics = [
  ...resourceInstance.epics,
  ...formInstance.epics,
  ...removeResourceInstance.epics,

  (actions$) =>
    actions$
      .ofType(LOAD_PROFILE)
      .merge(actions$.ofType(FETCH_PROFILE_SUCCESS))
      .map(({ model }) => {
        return initializeModel(model);
      }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).merge(actions$.ofType(FETCH_REMOVE_SUCCESS)).mapTo(close()),
];

export const { initializeModel, updateModel: updateProfile, validate, submit } = formInstance.actions;
export const { load: loadProfile, fetch: fetchProfile } = resourceInstance.actions;
export const { fetch: removeProfile } = removeResourceInstance.actions;

export function open(profile) {
  if (!profile || !profile.id) {
    profile = PaymentProfileDecorator.build(profile || {});
  }

  return (dispatch, getState) => {
    const { opened, profileId } = stateSelector(getState());
    if (!(opened && profileId === profile.id)) {
      dispatch({ type: OPEN, profile });
      if (profile.id && !profile.installments) {
        dispatch(fetchProfile());
      } else {
        dispatch(loadProfile(profile));
      }
    }

    const location = getState().app.location;
    if (location.query.editProfile != profile.id) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            editProfile: profile.id,
          },
        })
      );
    }
  };
}

export function close() {
  return (dispatch, getState) => {
    const { opened } = stateSelector(getState());
    if (opened) {
      dispatch({ type: CLOSE });
    }

    const location = getState().app.location;
    if (location.query.editProfile) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            editProfile: undefined,
          },
        })
      );
    }
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/EditPaymentProfileModal/index.js